import React from 'react'
import { Worker } from '@react-pdf-viewer/core';
import { Viewer } from '@react-pdf-viewer/core';
import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";
import { NullLogger } from '@microsoft/signalr';
import Modal from 'react-bootstrap/Modal';

const FileViewer = (props) => {

    const { isOpenPopup, onClose, file, type } = props
    const defaultLayoutPluginInstance = defaultLayoutPlugin();


    return (
        <Modal show={isOpenPopup} onHide={onClose} backdrop="static" keyboard={false} centered dialogClassName="app-modal modal-md hk-login-v1 hk-modal-v1">
            <Modal.Body>
                {/* {isLoading ? <Loader /> : null} */}

                <div className="download-header">
                    <div className='hide-me'></div>
                    <button className="btn-icon-transparent" onClick={onClose}>
                        <i className="icon-Icon-metro-cross"></i>
                    </button>
                </div>
                <div className="pdfView-box">

                    {type === "txt" ? file : type === "img" ? <img src={file} alt='Image' /> : null}

                </div>
                {type === "pdf" ?
                    <Worker workerUrl="https://unpkg.com/pdfjs-dist@2.16.105/build/pdf.worker.min.js">
                        <Viewer fileUrl={file}
                            defaultScale={1}
                            plugins={[defaultLayoutPluginInstance]} />
                    </Worker>
                    : null
                }
            </Modal.Body>
            <div className='btns-group text-end px-3 py-3 br-top-1 br-clr'>
                <button className='btn btn-gray' onClick={onClose}>Cancel</button>
            </div>
        </Modal>
    )
}

export default FileViewer
